/* eslint-disable jsx-a11y/anchor-is-valid */
import Box from '@mui/material/Box';
import Link from 'next/link';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import * as authPromptStyles from './AuthPrompt.styles';
import { PublicRoutePath } from '../../utils/routes';

interface AuthPromptPropsBase {
  buttonText?: string;
  text?: string;
}

interface AuthPromptPropsLink extends AuthPromptPropsBase {
  link: PublicRoutePath;
  onClick?: () => void;
}

interface AuthPromptPropsButton extends AuthPromptPropsBase {
  link?: PublicRoutePath;
  onClick: () => void;
}

export type AuthPromptProps = AuthPromptPropsLink | AuthPromptPropsButton;

function AuthPrompt({ onClick, link, buttonText = '', text = '' }: AuthPromptProps) {
  const { classes: clickableTypographyClasses } = authPromptStyles.useClickableTypography();

  const btnProps = link ? {} : { component: 'button' };

  const cta = (
    <MuiLink {...btnProps} onClick={onClick} className={clickableTypographyClasses.text} variant="h6">
      {buttonText}
    </MuiLink>
  );

  return (
    <Box display="flex" alignItems="center" mb={2} className={clickableTypographyClasses.wrapper}>
      <Typography component="span" variant="h6">
        {text}&nbsp;
        {link ? (
          <Link passHref href={link}>
            {cta}
          </Link>
        ) : (
          cta
        )}
      </Typography>
    </Box>
  );
}
export default AuthPrompt;
